/* src/components/navbar/nav-links.tsx */

"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

interface NavItem {
	href: string;
	text: string;
}

interface NavLinksProps {
	navItems: NavItem[];
}

export function NavLinks({ navItems }: NavLinksProps) {
	const pathname = usePathname();
	const [isHovering, setIsHovering] = useState(false);
	const [isAtTop, setIsAtTop] = useState(true);

	useEffect(() => {
		const handleScroll = () => {
			const scrollPercentage =
				(window.scrollY / document.documentElement.scrollHeight) * 100;
			setIsAtTop(scrollPercentage <= 5);
		};

		handleScroll(); // 初始检查
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div
			className="flex items-center space-x-8"
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
		>
			{navItems.map(({ href, text }) => {
				const isActive =
					href === "/" ? pathname === "/" : pathname.startsWith(href);

				return (
					<Link
						key={href}
						href={href}
						className="group relative flex flex-col items-center py-3"
					>
						<div
							className={`flex items-center text-lg group-hover:text-[var(--color-subtext)] transition-colors ${
								isActive
									? "text-[var(--theme-color-indicator)]"
									: "text-[var(--color-text)]"
							}`}
						>
							<span>{text}</span>
						</div>
						{isActive && isAtTop && (
							<motion.div
								layoutId="active-nav-indicator"
								className={`
									absolute bottom-0
									${
										isHovering
											? "w-full h-0.5 rounded-none bg-[var(--navbar-indicator-color)]"
											: "w-1.5 h-1.5 rounded-full bg-[var(--color-subtext)]"
									}
								`}
								transition={{
									type: "spring",
									stiffness: 350,
									damping: 30,
								}}
							/>
						)}

						{isActive && !isAtTop && (
							<div
								className={`
									absolute bottom-0
									${
										isHovering
											? "w-full h-0.5 rounded-none bg-[var(--navbar-indicator-color)]"
											: "w-1.5 h-1.5 rounded-full bg-[var(--color-subtext)]"
									}
								`}
							/>
						)}
					</Link>
				);
			})}
		</div>
	);
}
